<template>
    <Button :empty="empty" @click.prevent="onDTCreateClick">
        <template>
            Create a new Day Template
        </template>
    </Button>
</template>
<script>
    import EventBus from '@/eventbus';
    import Button from '@/components/common/Button.vue'
    export default {
        name: "DayTemplateCreationButton",
        extends: Button,
        props: {
            empty:Boolean
        },
        methods: {
            onDTCreateClick: () => { EventBus.$emit('onDayTemplateCreation'); },
        }
    }
</script>

<style scoped>
</style>
